import React, { useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Button, message } from "antd";
import { FileTextOutlined, DownloadOutlined } from "@ant-design/icons";
import { FormSelect } from "../../../common/formValidations";
import API from "../../../../app/helpers/devApi";
import "./TaxCertificateWidget.css";


export function TaxCertificateWidget() {
  const { auth } = useSelector(
    ({ auth }) => ({ auth: auth.coreModuleInfo }),
    shallowEqual
  );
  const employeeId = auth?.employee_id;

  const [selectedYear, setSelectedYear] = useState();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!employeeId) {
      message.error("Employee ID not found");
      return;
    }
    if (!selectedYear) {
      message.error("Please select a financial year");
      return;
    }

    try {
      setLoading(true);

      // Call the API to generate the certificate
      const payload = {
        employee_id: employeeId,
        year: parseInt(selectedYear, 10),
      };

      const response = await API.post(
        `/hrms-payroll-service/hrms_tax_employee_wise/tax-certificate/generate`,
        payload
      );

      const data = response?.data;
      if (data?.success && data?.data?.fileurl) {
        const fileurl = data.data.fileurl;
        // Construct the path for downloading
        const path = `hrms-payroll-service/${fileurl.replace(/^\//, "")}`;

        try {
          const blobRes = await API.get(path, { responseType: "blob" });
          const blob = blobRes?.data ?? blobRes;

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Form16_${selectedYear}.pdf`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
          message.success("Tax certificate downloaded successfully!");
        } catch (downloadErr) {
          console.error("Blob download failed:", downloadErr);
          // Fallback if Blob approach fails and URL is exposed directly
          if (process.env.REACT_APP_API_URL) {
            window.open(`${process.env.REACT_APP_API_URL}${fileurl}`, "_blank");
          } else {
            message.error("Failed to download the certificate file.");
          }
        }
      } else {
        message.error(data?.message || "Failed to generate tax certificate");
      }
    } catch (err) {
      console.error("Tax certificate generation failed:", err);
      message.error(err?.message || "An error occurred while generating the certificate");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tax-certificate-widget">
      <div className="tax-certificate-widget__header">
        <div className="tax-certificate-widget__icon-wrap">
          <FileTextOutlined />
        </div>
        <h3 className="tax-certificate-widget__title">Tax Certificate</h3>
      </div>

      <div className="tax-certificate-widget__content">
        <FormSelect
          name="year"
          slug="hrms_fy_year"
          value={selectedYear || undefined}
          onChange={(val) => setSelectedYear(val)}
          placeholder="Select Financial Year"
          style={{ width: "100%", marginBottom: "16px" }}
          size="large"
        />


        <Button
          type="primary"
          icon={<DownloadOutlined />}
          className="tax-certificate-widget__download-btn"
          size="large"
          onClick={handleDownload}
          loading={loading}
          disabled={loading}
        >
          Download Certificate
        </Button>
      </div>

      <div className="tax-certificate-widget__info-box">
        Tax certificates are generated after the financial year ends and employer files TDS returns.
      </div>
    </div>
  );
}

export default TaxCertificateWidget;
